// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconBoldLocation = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 16 16',
      fill: 'none',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M13.7467 5.63366C13.0467 2.55366 10.3601 1.16699 8.00006 1.16699C8.00006 1.16699 8.00006 1.16699 7.9934 1.16699C5.64006 1.16699 2.94673 2.54699 2.24673 5.62699C1.46673 9.06699 3.5734 11.9803 5.48006 13.8137C6.18673 14.4937 7.0934 14.8337 8.00006 14.8337C8.90673 14.8337 9.8134 14.4937 10.5134 13.8137C12.4201 11.9803 14.5267 9.07366 13.7467 5.63366ZM8.00006 8.97366C6.84006 8.97366 5.90006 8.03366 5.90006 6.87366C5.90006 5.71366 6.84006 4.77366 8.00006 4.77366C9.16006 4.77366 10.1001 5.71366 10.1001 6.87366C10.1001 8.03366 9.16006 8.97366 8.00006 8.97366Z',
      fill: 'currentColor',
    }),
  );

export { IconBoldLocation };
